<template>
    <div>
        <header-page></header-page>
        <full-page :options="options" id="fullpage">
            <div class="section" id="section0">
                <div class="slide" id="vosgesT">
                </div>
            </div>
            <div class="TitleBottom"><a
                    @click="$vuetify.goTo('#welcome',{ duration:1000, offset:0, easing:'easeInOutCubic'})">
                <h1>
                    <v-icon :size="screenwidth" color="white">mdi-chevron-down</v-icon>
                    Croustillance & Vosges Terroir
                </h1>
            </a></div>
        </full-page>
        <div>
            <div class="backgroundGreen" id="welcome">
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-8 col-lg-8" style="background:#577159;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <p>
                                            Croustillance est depuis 2016 le <b>seul traiteur labellisé Vosges
                                            Terroir</b>.<br>
                                            Ce partenariat avec la Chambre d’Agriculture a pour objectif de mettre à
                                            l’honneur les bons produits du terroir vosgien.
                                        </p>
                                        <h2 class="display-5 bottomH2">Notre engagement en faveur des produits
                                            locaux</h2>
                                        <p>
                                            Cette convention signée en 2016 entre Croustillance et la Chambre
                                            d’Agriculture des Vosges est le reflet de notre combat au service du goût et
                                            des produits de qualité.
                                        </p>
                                        <p>
                                            Croustillance s’engage à valoriser en priorité les spécialités issues de
                                            circuits courts, comme les productions labellisées <a
                                                href="https://vosges.chambre-agriculture.fr/circuits-courts/vosges-terroir/"
                                                target="_blank" class="LinkText">Vosges Terroir</a> ou <a
                                                href="https://www.bienvenue-a-la-ferme.com/grandest" target="_blank"
                                                class="LinkText">Bienvenue à la ferme</a>.
                                        </p>
                                        <p>
                                            Nous participons aussi aux comités de dégustation organisés par la Chambre
                                            d’Agriculture, afin de découvrir tous les produits Vosges Terroir et
                                            développer de nouveaux partenariats.
                                        </p>


                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/vosges-terroir-accueil.svg'); background-repeat: no-repeat; background-position: center center; background-size: cover; background-color:white;">
                            <div class="item media text-white alignLeft">
                                <div class="media-img">
                                    <div class="mask"></div>
                                    <img class="img-block" src="img/vosges-terroir-accueil.svg" alt="Vosges Terroir"
                                         style="display: none;">
                                    <div class="img"
                                         style="background-image: url('img/vosges-terroir-accueil.svg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/vosges-terroir/evenement-vosges-terroir.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-img">
                                    <div class="mask"></div>
                                    <img class="img-block" src="img/vosges-terroir/evenement-vosges-terroir.jpg" alt="Les événements Vosges Terroir"
                                         style="display: none;">
                                    <div class="img"
                                         style="background-image: url('img/vosges-terroir/evenement-vosges-terroir.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-8 col-lg-8" style="background:#816840;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h2 class="display-5 bottomH2">Comment déguster les produits Vosges Terroir par
                                            Croustillance ?</h2>
                                        <p>
                                            En nous le demandant, tout simplement ! Un repas d’entreprise, un mariage ou
                                            un buffet sont d’excellentes occasions de mettre en avant la qualité et le
                                            savoir-faire de nos producteurs locaux. </p>

                                        <p>
                                            Nous vous promettons de cuisiner les <b>meilleurs produits Vosges
                                            Terroir</b> disponibles, en fonction des délais et de la saison.
                                        </p>
                                        <p>
                                            Croustillance est à l’écoute de tous vos projets, même les plus audacieux.
                                            Il y a quelques semaines, nous avons par exemple servi un cocktail
                                            déjeunatoire à base de produits Vosges Terroir… dans une étable, au cul des
                                            vaches !
                                        </p>
                                        <p>
                                            Nous vous invitons également à participer à la <a
                                                href="https://cda-vosges.com/accueil-__1__1__"
                                                target="_blank" class="LinkText">marche dégustation</a> organisée chaque
                                            année au printemps au Château d’Épinal. C’est nous qui préparons les petits
                                            plats que vous y savourez...
                                        </p>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-8 col-lg-8" style="background:#b9bb2f;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h2 class="display-5 bottomH2">Croustillance & les animations Vosges
                                            Terroir </h2>
                                        <p>
                                            Le traiteur Croustillance s’associe régulièrement à la Chambre d’Agriculture
                                            pour cuisiner et servir des produits Vosges Terroir lors de grands
                                            événements. En voici quelques exemples :
                                        </p>
                                        <p class="pAlpha">
                                        <ul>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Salon de l’Agriculture (démonstrations et déjeuners pour la presse,
                                                cocktail Journée Vosges)
                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Marché estival des producteurs Place des Vosges à Épinal

                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Festival International de Géographie de Saint-Dié
                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Soirée des Ambassadeurs de Lorraine au Conseil départemental des Vosges
                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Passage du Tour de France à Vittel
                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Visite du Président de la République aux Voivres, etc.
                                            </li>
                                        </ul>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/vosges-terroir/salon-agriculture.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-img">
                                    <div class="mask"></div>
                                    <img class="img-block" src="img/vosges-terroir/salon-agriculture.jpg" alt="Les événements Vosges Terroir"
                                         style="display: none;">
                                    <div class="img"
                                         style="background-image: url('img/vosges-terroir/salon-agriculture.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/vosges-terroir/plats-menu.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-img">
                                    <div class="mask"></div>
                                    <img class="img-block" src="img/vosges-terroir/plats-menu.jpg" alt="Vosges Terroir"
                                         style="display: none;">
                                    <div class="img"
                                         style="background-image: url('img/vosges-terroir/plats-menu.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-8 col-lg-8" style="background:#8c9625;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <p class="desc">
                                    <h2 class="display-5 bottomH2">Quelques produits Vosges Terroir souvent
                                        employés </h2>
                                    <p class="pAlpha">
                                    <ul>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Le safran des Payoux du Val d’Ajol
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Les jus de fruits du GAEC des Terres Rouges de Maronchamp
                                            La viande et les charcuteries de la Ferme de la Blonde à Fauconcourt
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Les vins de rhubarbe de la Maison Moine à Xertigny
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Les apéritifs de fruits du Domaine du Beaucerf à Ventron
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Les crèmes de mirabelle Lecomte-Blaise au Syndicat
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            La Miranille d’En Forges à Liffol-le-Grand
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Les fromages du GAEC des Hetz à Moyemont
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Les charcuteries Pierrat au Tholy
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            La bière bio de la brasserie l’Opercule à Senones
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Les pâtés lorrains de la boulangerie Nedelec à Épinal
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            La spiruline de Spirul’in Vosges à Rancourt
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Les infusions de bonbons de la Confiserie des Hautes-Vosges à Plainfaing
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Le thé vert sapin des Cafés Canton à Granges-sur-Vologne
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Les escargots de la Fermette aux Escargots à Romont
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            La farine du Moulin de Nomexy
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Les pâtes de l’Atelier à pâtes à Thiéfosse
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Les pommes de terre de la ferme Menzin à Essegney
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Les légumes des Jardins du Pervis à Monthureux-sur-Saône
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Le pop-corn de Papy Pop Corn à Gérardmer
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            L’huile de colza du GAEC Robinet à Savigny
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            L’andouille du Val d’Ajol de la boucherie Husson au Val d’Ajol
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Le fromage aux herbes du GAEC du Perhy à Cornimont
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Le miel de l’apiculteur Pascal Rzadkiewa à Saint-Nabord
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Les pâtes à tartiner de la Crêpe E-Claire de Bulgnéville
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            La farine de pois chiche & les lentilles bio de la ferme Malglaive à Harol
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            La truite de la pisciculture du Frais Barril à Xertigny
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Les confitures et les sirops des Petits Fruits de la Hutte à Tendon, etc.
                                        </li>
                                    </ul>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-page> </footer-page>
    </div>

</template>

<script>
    import HeaderPage from './headerPage'
    import FooterPage from './footerPage'

    export default {
        name: 'vosgesTerroir',
        components: {
            HeaderPage,
            FooterPage
        },
        data() {
            return {
                options: {
                    licenseKey: 'A32C7F42-F0FE4A04-AAB7E182-AB1F9C8B',
                    navigation: false,
                    scrollBar: true,
                    autoScrolling: false,
                    fitToSection: false
                }
            }
        },
        methods: {
            afterLoad() {
                console.log('After load')
            },
        },
        computed: {
            screenwidth() {
                if (screen.width > 400) {
                    return 70
                } else {
                    return 30
                }
            }
        },
        created() {
            document.getElementsByTagName('meta')["description"].content = "Depuis 2016, Croustillance est le seul traiteur labellisé Vosges Terroir. Dans nos menus, nous mettons à l’honneur les bons produits du terroir vosgien.";
            document.title = "Croustillance, le seul traiteur labellisé Vosges Terroir !";
        }
    }
</script>

<style>
    #vosgesT {
        background: url('/img/vosges-terroir/Fred-Julie-Vosges-Terroir.jpg') no-repeat center center;
        padding: 0 0 0 0;
        background-size: cover;
    }
</style>